export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";